import arrayUtils from '../../utils/arrayUtils';

const REQUESTS_RESPONSES_COUNT = 5;

const getErrorDetails = ({allRequests, currentIndex, response}) => {
    const result = {};

    result.lastRequestFrames = getLastRequestsList(allRequests, currentIndex);

    if (response) {
        result.lastResponseFrames = getLastResponsesList(response);
    }

    return result;
};

const getLastRequestsList = (fullList, currentIndex) => {
    const startIndex = currentIndex > REQUESTS_RESPONSES_COUNT ? currentIndex - REQUESTS_RESPONSES_COUNT : 0;
    const slicedList = fullList.slice(startIndex, currentIndex + 1).map(({f}) => f);

    return arrayUtils.fillArray(REQUESTS_RESPONSES_COUNT, slicedList);
};

const getLastResponsesList = (response) => arrayUtils.fillArray(REQUESTS_RESPONSES_COUNT, [response]);

export default {
    getErrorDetails,
    getLastRequestsList,
    getLastResponsesList,
};
